/* eslint-disable */
import {
  PICKUP_GRID_END,
  PICKUP_GRID_START,
  PICKUP_SLOT_INTERVAL_MINUTES,
  generatePickupSlots,
  slotsWithinRange,
} from '@/data/pickupTime';

//pickupTimeFrom and PickupTimeUntil are dependent from implementation
export default {
  data() {
    return {
      pickupTimeData: {
        pickupTimeUntil: '',
        pickupTimeFrom: '',
        pickupTimeZone: '+02:00',
        pickupTimeZoneCurrentTime: 'XX:XX',
      },
      returnHoursArray: {
        from: [],
        until: []
      },
      //Slot step comes from PICKUP_SLOT_INTERVAL_MINUTES in '@/data/pickupTime'
      scheduleHours: generatePickupSlots(PICKUP_GRID_START, PICKUP_GRID_END, PICKUP_SLOT_INTERVAL_MINUTES),
      timeZones: [
        { value: "-12:00", text: "UTC-12:00" },
        { value: "-11:00", text: "UTC-11:00" },
        { value: "-10:00", text: "UTC-10:00" },
        { value: "-09:00", text: "UTC-09:00" },
        { value: "-08:00", text: "UTC-08:00" },
        { value: "-07:00", text: "UTC-07:00" },
        { value: "-06:00", text: "UTC-06:00" },
        { value: "-05:00", text: "UTC-05:00" },
        { value: "-04:00", text: "UTC-04:00" },
        { value: "-03:30", text: "UTC-03:30" },
        { value: "-03:00", text: "UTC-03:00" },
        { value: "-02:00", text: "UTC-02:00" },
        { value: "-01:00", text: "UTC-01:00" },
        { value: "+00:00", text: "UTC+00:00" },
        { value: "+01:00", text: "UTC+01:00" },
        { value: "+02:00", text: "UTC+02:00" },
        { value: "+03:00", text: "UTC+03:00" },
        { value: "+03:30", text: "UTC+03:30" },
        { value: "+04:00", text: "UTC+04:00" },
        { value: "+04:30", text: "UTC+04:30" },
        { value: "+05:00", text: "UTC+05:00" },
        { value: "+05:30", text: "UTC+05:30" },
        { value: "+05:45", text: "UTC+05:45" },
        { value: "+06:00", text: "UTC+06:00" },
        { value: "+06:30", text: "UTC+06:30" },
        { value: "+07:00", text: "UTC+07:00" },
        { value: "+08:00", text: "UTC+08:00" },
        { value: "+09:00", text: "UTC+09:00" },
        { value: "+09:30", text: "UTC+09:30" },
        { value: "+10:00", text: "UTC+10:00" },
        { value: "+11:00", text: "UTC+11:00" },
        { value: "+12:00", text: "UTC+12:00" },
        { value: "+13:00", text: "UTC+13:00" }
      ],
    }
  },
  computed: {
  },
  methods: {
    /**
     * When we have pickup product we are using this function for setting pickup times
     * @param pickupProduct
     * @param timeZone
     * @param shouldResetTimes
     */
    setBulkPickupTimeRange(pickupProduct, timeZone, shouldResetTimes) {
      let currentDate = this.getFormatedDate(new Date());
      currentDate.time = this.getTimeInGMT(timeZone)
      this.pickupTimeData.pickupTimeZoneCurrentTime = currentDate.time;
      const pickupDate = this.getFormatedDate(this.pickupDate);
      this.setDefaultPickupTimes(currentDate, pickupDate, this.getLocation());
      this.updatePickupTimes(currentDate, pickupDate, shouldResetTimes)
      // console.log('current date' )
      // console.log(currentDate)
      // console.log('pickup date')
      // console.log(pickupDate)
      // console.log(this.pickupDate)
      this.returnHoursArray.from = this.getBulkPickupTimeFromRangeArray(currentDate, pickupDate, pickupProduct);
      this.returnHoursArray.until = this.getBulkPickupTimeUntilRangeArray(currentDate, pickupDate, pickupProduct);
      //console.log(this.pickupTimeData)
    },
    /**
     * We are using this function on booking page when we dont have pickup product set
     * @param timeZone
     * @param shouldResetTimes
     */
    setNormalPickupTimeRange(timeZone, shouldResetTimes) {
      let currentDate = this.getFormatedDate(new Date(new Date().toLocaleDateString("en-US") + " " + this.getTimeInGMT(timeZone)))
      let pickupDate = this.getFormatedDate(this.pickupDate);
      currentDate.time = this.getTimeInGMT(timeZone)
      this.pickupTimeData.pickupTimeZoneCurrentTime = currentDate.time;
      this.setDefaultPickupTimes(currentDate, pickupDate, this.getLocation()); //manipulacija pickupTimeFrom i pickupTimeUntil mora da bude iznad logike za kreiranje ranga
      this.updatePickupTimes(currentDate, pickupDate, shouldResetTimes);

      let startFromHour,
        endFromHour,
        startUntilHour,
        endUntilHour;

      let dayStartingTime;
      if (currentDate.date === pickupDate.date) {
        dayStartingTime = currentDate.time;
      } else {
        dayStartingTime = '05:00';
      }

      let addTime = '+01:00';
      let subTime = '-01:00';
      // //Spec case for DHL Express
      // if (pickupAgentId && parseInt(pickupAgentId) === 8) {
      //   addTime = '+02:00';
      //   subTime = '-02:00';
      // }
      if(this.pickupTimeData.pickupTimeFrom === '' && this.pickupTimeData.pickupTimeUntil === ''){
        // Ako nema odabranih vremena
        startFromHour = dayStartingTime < '06:00' ? '06:00' : this.roundUpToPickupInterval(dayStartingTime);
        endFromHour = '18:00'
        startUntilHour = this.addTime(startFromHour, addTime);
        endUntilHour = '20:00';
      } else if(this.pickupTimeData.pickupTimeFrom == '' && this.pickupTimeData.pickupTimeUntil != ''){
        // Ako je until vec odabran
        startFromHour = dayStartingTime < '06:00' ? '06:00' : this.roundUpToPickupInterval(dayStartingTime);
        endFromHour = this.findEndHour(this.pickupTimeData.pickupTimeUntil);
        startUntilHour = this.pickupTimeData.pickupTimeUntil;
        endUntilHour = '20:00';
      } else if (this.pickupTimeData.pickupTimeFrom != '' && this.pickupTimeData.pickupTimeUntil == ''){
        // Ako je from vec odabran, a nema until
        startFromHour = this.pickupTimeData.pickupTimeFrom;
        endFromHour = '18:00';
        startUntilHour = this.addTime(this.pickupTimeData.pickupTimeFrom, addTime);
        endUntilHour = '20:00';
      } else if (this.pickupTimeData.pickupTimeFrom  != '' && this.pickupTimeData.pickupTimeUntil != ''){
        // Ako ima obe vrednosti
        startFromHour = dayStartingTime < '06:00' ? '06:00' : this.roundUpToPickupInterval(dayStartingTime);
        endFromHour = this.addTime(this.pickupTimeData.pickupTimeUntil, subTime);
        startUntilHour = this.addTime(this.pickupTimeData.pickupTimeFrom, addTime);
        endUntilHour = '20:00';
      }

      //Mora da bude ovde da bi se formirali start i end hour
      //If not shown time in select, reset prop
      if (!this.findArrayRangeHours(startFromHour, endFromHour).length) {
        this.pickupTimeData.pickupTimeFrom = ''
      }

      //Mora da bude ovde da bi se formirali start i end hour
      //If not shown time in select, reset prop
      if (!this.findArrayRangeHours(startUntilHour, endUntilHour).length) {
        this.pickupTimeData.pickupTimeUntil = ''
      }

      // console.log(startFromHour, endFromHour)
      // console.log(this.findArrayRangeHours(startFromHour, endFromHour))
      // console.log(startUntilHour, endUntilHour)
      // console.log(this.findArrayRangeHours(startUntilHour, endUntilHour))

      this.returnHoursArray.from = this.findArrayRangeHours(startFromHour, endFromHour);
      this.returnHoursArray.until = this.findArrayRangeHours(startUntilHour, endUntilHour);
    },
    resetPickupTimes(currentDate, pickupDate) {
      const currentLocalTime = currentDate.time; //this.getTimeInGMT(this.pickupTimeZone)

      //Setuj trenutno lokalno vreme u pickupTimeFrom, ako je trenutno lokalno vreme preslo pickupTimeFrom
      if (currentDate.date === pickupDate.date && currentLocalTime > this.pickupTimeData.pickupTimeFrom) {
        this.pickupTimeData.pickupTimeFrom = this.roundUpToPickupInterval(currentLocalTime);
      }

      //ako je trenutno lokalno vreme + 1:00h vece od pickupTimeUntil, setuj lokalno + 1:00h
      const currentPlusHour = this.addTime(this.roundUpToPickupInterval(currentLocalTime), '+01:00');
      if (currentDate.date === pickupDate.date && currentPlusHour > this.pickupTimeData.pickupTimeUntil) {
        this.pickupTimeData.pickupTimeUntil = currentPlusHour;
      }
    },
    setDefaultPickupTimes(currentDate, pickupDate, location) {
      if (!location) {
        console.log('Pickup location not found');
        return;
      }

      if (!location.pickup_time) {
        return;
      }

      const pickupTime       = location.pickup_time[pickupDate.dayOfWeek.toLowerCase()];
      const currentLocalTime = this.getTimeInGMT(this.pickupTimeData.pickupTimeZone)
      if (!this.pickupTimeData.pickupTimeFrom) {
        //Set default pickup time from only if field is not already set or current local time is bigger then default pickup from
        if (pickupDate.date === currentDate.date) {
          this.pickupTimeData.pickupTimeFrom = pickupTime.from;
        } else if (pickupDate.date > currentDate.date) {
          this.pickupTimeData.pickupTimeFrom = pickupTime.from;
        }
      }
      if (!this.pickupTimeData.pickupTimeUntil) {

        if (pickupDate.date === currentDate.date && currentLocalTime < pickupTime.to) {
          this.pickupTimeData.pickupTimeUntil = pickupTime.to;
        } else if (pickupDate.date > currentDate.date) {
          this.pickupTimeData.pickupTimeUntil = pickupTime.to;
        }
      }
    },
    findEndHour(hour) {
      let hours = Number(hour.slice(0, 2)) - 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      let minutes = hour.slice(3);
      return hours + ':' + minutes;
    },
    /**
     * Dropdown options for every slot of the grid inside [from, to].
     * Endpoints need not sit on the grid - an off-grid carrier time narrows the
     * range instead of emptying it, which is what an indexOf() slice used to do.
     */
    findArrayRangeHours(from, to) {
      return slotsWithinRange(from, to, this.scheduleHours).map((time) => {
        return {text: time, value: time};
      });
    },
    updatePickupTimes(currentDate, pickupDate, shouldResetTimes) {
      if (shouldResetTimes) {
        this.pickupTimeData.pickupTimeFrom = '';
        this.pickupTimeData.pickupTimeUntil = '';
        return;
      }

      const currentLocalTime = this.getTimeInGMT(this.pickupTimeData.pickupTimeZone)

      //Setuj trenutno lokalno vreme u pickupTimeFrom, ako je trenutno lokalno vreme preslo pickupTimeFrom
      if (currentDate.date === pickupDate.date && this.pickupTimeData.pickupTimeFrom && currentLocalTime > this.pickupTimeData.pickupTimeFrom) {
        this.pickupTimeData.pickupTimeFrom = this.roundUpToPickupInterval(currentLocalTime);
      }

      //ako je trenutno lokalno vreme + 1:00h vece od pickupTimeUntil, setuj lokalno + 1:00h
      const currentPlusHour = this.addTime(this.roundUpToPickupInterval(currentLocalTime), '+01:00');
      if (currentDate.date === pickupDate.date && this.pickupTimeData.pickupTimeUntil && currentPlusHour > this.pickupTimeData.pickupTimeUntil) {
        this.pickupTimeData.pickupTimeUntil = currentPlusHour;
      }
    },
    isPickupToday() {
      const timeZone = this.pickupTimeData.pickupTimeZone;
      let currentDate = this.getFormatedDate(new Date());
      currentDate.time = this.getTimeInGMT(timeZone)
      const pickupDate = this.getFormatedDate(this.pickupDate);

      return currentDate.date === pickupDate.date;
    },
    getBulkPickupTimeFromRangeArray(currentDate, pickupDate, pickupProduct) {
      // Normalize inputs
      const normalizedCurrentDate = currentDate || this.getFormatedDate(new Date());
      const normalizedPickupDate = pickupDate || this.getFormatedDate(this.pickupDate);
      const currentTime = this.roundUpToPickupInterval(normalizedCurrentDate.time);
      const isSameDay = normalizedCurrentDate.date === normalizedPickupDate.date;

      // Calculate start and end times
      let startTime = this.getPickupFromStartTime(normalizedCurrentDate, normalizedPickupDate, pickupProduct);
      let endTime = this.getPickupFromEndTime(pickupProduct);

      // Validate time window
      if (isSameDay && this.isTimeAfter(currentTime, endTime)) {
        return []; // Too late for pickup today
      }

      if (this.isTimeAfter(startTime, endTime)) {
        return []; // Invalid time range
      }

      return this.findArrayRangeHours(startTime, endTime);
    },
    getBulkPickupTimeUntilRangeArray(currentDate, pickupDate, pickupProduct) {
      // Early return if no base pickup time
      if (!this.pickupTimeData?.pickupTimeFrom) {
        return [];
      }

      // Normalize inputs
      const normalizedCurrentDate = currentDate || this.getFormatedDate(new Date());
      const normalizedPickupDate = pickupDate || this.getFormatedDate(this.pickupDate);
      const currentTime = this.roundUpToPickupInterval(normalizedCurrentDate.time);
      const isSameDay = normalizedCurrentDate.date === normalizedPickupDate.date;

      // Carrier-specific logic
      const shippingAgentId = parseInt(pickupProduct?.shipping_agent_id);
      const isDhlOrFedex = this.isDhlOrFedex(shippingAgentId);
      const timeOffset = isDhlOrFedex ? '+02:00' : '+01:00';

      // Calculate start time with progressive logic
      let startTime = this.addTime(this.pickupTimeData.pickupTimeFrom, timeOffset);

      // If same day and current time is later, use current time
      if (isSameDay && this.isTimeAfter(currentTime, startTime)) {
        startTime = currentTime;
      }

      // Apply business rules in order
      startTime = this.getLatestTime(startTime, '12:00'); // Never before noon

      // Calculate end time
      let endTime = this.getPickupUntilEndTime(pickupProduct, isDhlOrFedex);

      // DHL Express specific ready time (assuming ready_time is in local time)
      if (isDhlOrFedex && pickupProduct?.ready_time) {
        const plusTwoHourReadyTime = this.addTime(pickupProduct.ready_time, timeOffset);
        startTime = this.getLatestTime(startTime, plusTwoHourReadyTime);
        if (this.isTimeAfter(startTime, endTime)) {
          let fallback = this.addTime(this.pickupTimeData.pickupTimeFrom, '+01:30');
          if (isSameDay && this.isTimeAfter(currentTime, fallback)) {
            fallback = currentTime;
          }
          startTime = this.getLatestTime(fallback, '12:00');
        }
      }

      // Validate time window
      if (isSameDay && this.isTimeAfter(currentTime, endTime)) {
        return []; // Too late for pickup today
      }

      if (this.isTimeAfter(startTime, endTime)) {
        return []; // Invalid time range
      }

      return this.findArrayRangeHours(startTime, endTime);
    },
    // Helper methods (add these to your class)
    isTimeAfter(time1, time2) {
      return time1 > time2; // Assumes HH:MM format, works for string comparison
    },
    getLatestTime(time1, time2) {
      return this.isTimeAfter(time1, time2) ? time1 : time2;
    },
    // Helper method for calculating "from" start time
    getPickupFromStartTime(currentDate, pickupDate, pickupProduct) {
      const currentTime = this.roundUpToPickupInterval(currentDate.time);
      const isSameDay = currentDate.date === pickupDate.date;

      let baseStartTime = '09:00';

      // DHL Express uses ready_time as base start time if available
      // if (isDHLExpress && pickupProduct?.ready_time) {
      //   baseStartTime = pickupProduct.ready_time;
      // }

      // If same day and current time is later, use current time
      if (isSameDay && this.isTimeAfter(currentTime, baseStartTime)) {
        return currentTime;
      }

      return baseStartTime;
    },
    getPickupFromEndTime(pickupProduct) {
      if (!pickupProduct) {
        return '16:00'; // Default fallback
      }

      const shippingAgentId = parseInt(pickupProduct.shipping_agent_id);
      const closeTime = pickupProduct.close_time || '17:30';

      // Special handling for GLS Express (10) and UPS (6)
      if ([10, 6].includes(shippingAgentId) && pickupProduct.ready_time) {
        return pickupProduct.ready_time;
      }

      // Calculate time buffer before close time
      const timeBuffer = this.isDhlOrFedex(shippingAgentId) ? '-02:00' : '-01:30'; // DHL Express or Fedex vs others

      return this.addTime(closeTime, timeBuffer);
    },
    getPickupUntilEndTime(pickupProduct, isDhlOrFedex) {
      const defaultEndTime = '18:00';

      if (!pickupProduct?.close_time) {
        return defaultEndTime;
      }

      // DHL Express always uses close_time if available
      if (isDhlOrFedex) {
        return pickupProduct.close_time;
      }

      // Other carriers: use close_time only if it's after default
      return this.isTimeAfter(pickupProduct.close_time, defaultEndTime)
        ? pickupProduct.close_time
        : defaultEndTime;
    },
    isDhlOrFedex(shippingAgentId) {
      return [8, 9].includes(parseInt(shippingAgentId));
    }
  },
}
